<script setup>
import {ref} from 'vue'

const cancelRemark = ref(null)

const props = defineProps({
    leave: {
        type: Object,
        required: true
    },
    iconMap: {
        type: Object
    },
    wordingMap: {
        type: Object
    }
})

const emit = defineEmits(['delete', 'cancel'])

function remove(id){
    emit('delete', id)
}

function cancel(id, remark) {
    emit('cancel', id, remark)
    this.cancelRemark = null;
}

function formatTime(datetime){
    return dayjs(datetime).format('YYYY-MM-DD HH:mm')
}
</script>

<template>
    <div class=" rounded bg-gray-400 px-4 py-4">
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">Start</div>
            <div class="text-2xl  text-white">{{formatTime(leave.begin_time)}}</div>
        </div>
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">End</div>
            <div class="text-2xl text-white">{{formatTime(leave.end_time)}}</div>
        </div>
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">Hours</div>
            <div class="text-2xl text-white">{{leave.leave_hours}}</div>
        </div>
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">Type</div>
            <div class="text-2xl text-white">{{leave.leave_type}}</div>
        </div>
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">Reason</div>
            <div class="text-2xl text-white">{{leave.remark}}</div>
        </div>
        <div v-if="leave.approve_desc" class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">response</div>
            <div class="text-2xl text-white">{{leave.approve_desc}}</div>
        </div>
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">Status</div>
            <div class="text-2xl text-white">{{ iconMap[leave.status] + ' ' + wordingMap[leave.status] }}</div>
        </div>
        <div class="flex justify-center mt-4">
            <button v-if="leave.cancelable" @click="remove(leave.id)" class="px-4 py-4 text-center text-xl rounded bg-rose-400 hover:bg-rose-600 text-white">
                <span> 🧹 cancel apply</span>
            </button>
            <div v-else-if="leave.can_apply_cancel">
                <div class="text-gray-100 my-1 font-bold">Cancel remark</div>
                <textarea placeholder="remark" v-model="cancelRemark"></textarea>
                <div v-if="!!cancelRemark">
                    <button @click="cancel(leave.id, cancelRemark)" class="px-4 py-4 text-center text-xl rounded bg-teal-400 hover:bg-teal-600 text-white">
                        <span> 🛬 cancel leave</span>
                    </button>
                </div>

            </div>

        </div>
    </div>
</template>


